module.exports = __webpack_public_path__ + "media/components/t-shirt-comp/static/Playa-El-Palmar-58477ea55e1dd205b38de9648c3aeaff.jpg";